import { getCustomStatisticViewFields, getViewCustomStatisticConfig, getViewVariableOption, useAtomData } from '@lighthouse/shared'
import { useDeferredValue, useMemo } from 'react'

import { dataSourceAtomFamily } from '@/atoms/dataSource/state'

import { useCurrentAppId, useCurrentEnvId } from './useApplication'
import { useCurrentCustomViewBlock } from './useCurrentCustomViewBlock'

/**
 * 获取当前选中 block 所属 CustomView 的变量选项
 * 用于富文本等需要 customViewOption 的场景
 */
export function useVariableCustomViewOption() {
    const appId = useCurrentAppId()
    const envId = useCurrentEnvId()
    const customView = useCurrentCustomViewBlock()
    const customViewDsId = useDeferredValue(customView?.config.pointer)

    const customViewDataSource = useAtomData(dataSourceAtomFamily({ appId, envId, dsId: customViewDsId || '' }))
    const extraFields = useMemo(
        () => getCustomStatisticViewFields(getViewCustomStatisticConfig(customView?.config), customViewDataSource?.id),
        [customView, customViewDataSource?.id]
    )

    const customViewOption = useMemo(
        () =>
            customViewDataSource &&
            getViewVariableOption({
                dataSource: customViewDataSource,
                viewType: 'custom',
                extraFields
            }),
        [customViewDataSource, extraFields]
    )

    return { customViewOption, customViewDataSource }
}
